import {
  BODY_SKINS,
  INVENTORY,
  PLACEMENT_TYPE_ENEMY,
  PLACEMENT_TYPE_HERO,
  PLACEMENT_TYPE_ROAMING_ENEMY,
} from "../helpers/consts";
import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";

export class WaterTilePlacement extends Placement {
  isSolid(forBody) {
    // Enemies turn around when stepping near water
    return (
      forBody.type === PLACEMENT_TYPE_ENEMY ||
      forBody.type === PLACEMENT_TYPE_ROAMING_ENEMY
    );
  }

  damagesBodyOnCollide(forBody) {
    return (
      forBody.type === PLACEMENT_TYPE_HERO &&
      !this.level.inventory.has(INVENTORY.WATER_PICKUP)
    );
  }

  changeHeroSkinOnCollide() {
    return BODY_SKINS.WATER;
  }

  renderComponent() {
    return <Sprite frameCoord={this.level.animatedTiles.waterFrame} />;
  }
}
